document.addEventListener('DOMContentLoaded', function() {
  // contact form: move input field "tumorTypeOther" into last option of radio "tumorType"

  let inputFieldTumorTypeOther = $('[name$="[patientInfo-tumorTypeOther]"]');
  let inputContainerTumorTypeOther = inputFieldTumorTypeOther.parents('.text-field');
  inputFieldTumorTypeOther.appendTo($('[id$="patientInfo-tumorType"] label:last-child')).hide();
  inputContainerTumorTypeOther.remove();

  if ($('[id$="patientInfo-tumorType"] label:last-child input[type="radio"]').is(':checked')) {
    inputFieldTumorTypeOther.fadeIn(250);
  }

  $('[id$="patientInfo-tumorType"] .kid-form__input-wrapper').on(
    'click',
    'input[type="radio"]',
    function() {
      if (
        $(this)
          .parents('label')
          .is(':last-child')
      ) {
        inputFieldTumorTypeOther.fadeIn(250);
      } else {
        $(this);
        inputFieldTumorTypeOther.fadeOut(250);
      }
    }
  );
});

const fileUploadLabel = (_caller) => {
  console.log(_caller);
  var label = _caller.parents('.fileupload-field').find('label span');

  if (
    (_caller[0].files && _caller[0].files.length > 0) ||
    _caller.parents('.fileupload-field').find('label div').length > 0
  ) {
    if (_caller[0].files && _caller[0].files.length > 0) {
      label.text(_caller[0].files[0].name);
    } else {
      label.text(
        _caller
          .parents('.fileupload-field')
          .find('label div')
          .text()
      );
      _caller
        .parents('.fileupload-field')
        .find('label div')
        .remove();
    }
  } else {
    label.text('Keine Datei ausgewählt');
  }
};

document.addEventListener('DOMContentLoaded', function(event) {
  $('input[type="file"]').each(function() {
    fileUploadLabel($(this));
  });

  $('.kid-form').on('change', 'input[type="file"]', function() {
    fileUploadLabel($(this));
  });
});

/* Die Funktion */

function fileUploadStyling(single, multiple) {
  let input = document.querySelectorAll('input[type=file]');
  for (let i = 0; i < input.length; i++) {
    var inputFile = input[i];
    inputFile.addEventListener('change', function(e) {
      var label = $(this).parent('label');

      if (this.files && this.files.length > 1) {
        label.innerHTML = this.files.length + ' ' + multiple;
      } else {
        label.innerHTML = this.files[0].name + ' ' + single;
      }
    });
  }
}
